import React, { Component } from "react";
import PropTypes from "prop-types";
import { Alert } from "reactstrap";
import {uid} from "react-uid";
import AutocompleteCompany from "../common/autocomplete_company";
import InvalidFeedback from "../../../common/invalid_feedback";

class InvestmentForm extends Component {
  constructor(props) {
    super(props);

    this.initialCompany = {
      id: null,
      name: "",
      website_url: "",
      logo_image: "",
      errors: {}
    };

    this.state = {
      company: Object.assign({}, this.initialCompany),
      previewLogoImage: {
        file_name: "画像ファイルの選択",
        url: ""
      },
      isSaving: false,
      isShown: false,
      errors: [],
    };
  }

  onCompanyChange = (event, value) => {
    const { company } = this.state;
    const field = event.target.name;
    company[field] = value || event.target.value;
    this.setState({ company: company });
  }

  setCompany = (company) => {
    this.setState({ company: company });
  }

  onPreviewLogoImageChange = (event) => {
    const file = event.target.files[0];
    const file_name = event.target.value.replace(/\\/g, "/").replace(/.*\//, "");

    this.onCompanyChange(event, file);

    if (!file) return;
    if (/^image/.test(file.type)) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({ previewLogoImage: { file_name: file_name, url: reader.result } });
      };
      reader.readAsDataURL(file);
    }
  }

  handleFormSubmit = (event) => {
    event.preventDefault();
    this.setState({ isSaving: true });

    const { actions, handleEditModeLinkClick } = this.props;
    const { company } = this.state;

    actions.addInvestment(company).then(() => {
      this.setState({ isSaving: false, isEditing: false });
      handleEditModeLinkClick();
    }).catch(response => {
      this.setState({
        errors: response.errors,
        company: response.company,
        isSaving: false
      });
    });
  }

  updateShown = (flag) => {
    this.setState({isShown: flag});
  }

  render () {
    const { defaultCompanyImage, handleEditModeLinkClick } = this.props;
    const { company, previewLogoImage, isSaving, isShown, errors } = this.state;

    return (
      <form>
        <div className='add-company'>
          <h3>投資先の追加</h3>

          { errors.length > 0 && (
            <Alert color='danger' className='popup'>
              <ul>
                { errors.map((error, index) => {
                  return <li key={uid(error, index)}>{error.message}</li>;
                })}
              </ul>
            </Alert>
          )}

          <div className='form-group row mb-4'>
            <label className='col-12 col-md-3 col-form-label' htmlFor='company_name'>会社名</label>
            <div className='col-12 col-md-9'>
              <AutocompleteCompany
                {...this.state}
                disabled={false}
                defaultCompanyImage={defaultCompanyImage}
                setCompany={this.setCompany}
                updateShown={this.updateShown}
              />
            </div>
          </div>

          {isShown === true && (
            <React.Fragment>
              <div className='form-group row mb-4'>
                <label className='col-12 col-lg-3 col-form-label' htmlFor='company_website_url'>WebサイトURL</label>
                <div className='col-12 col-lg-9'>
                  <input
                    name='website_url'
                    className={`${company.errors.website_url ? "form-control is-invalid" : "form-control"}`}
                    type='text'
                    value={company.website_url}
                    placeholder='https://yourcompany.com'
                    id='company_website_url'
                    onChange={this.onCompanyChange}
                  />
                  <InvalidFeedback errors={company.errors.website_url} label='WebサイトURL' />
                </div>
              </div>

              <div className='form-group row mb-4'>
                <label className='col-12 col-lg-3 col-form-label' htmlFor='company_logo_image'>ロゴ</label>
                <div className='col-12 col-lg-9'>
                  <div className='custom-file mb-3'>
                    <input
                      name='logo_image'
                      className={`${company.errors.logo_image ? "custom-file-input is-invalid" : "custom-file-input"}`}
                      type='file'
                      id='company_logo_image'
                      onChange={this.onPreviewLogoImageChange}
                    />
                    <label className='custom-file-label' htmlFor='company-logo-image'>
                      {previewLogoImage.file_name}
                    </label>
                    <InvalidFeedback errors={company.errors.logo_image} />
                  </div>
                  <img
                    src={previewLogoImage.url || defaultCompanyImage}
                    alt="ロゴ"
                    className='logo-preview'
                  />
                </div>
              </div>
            </React.Fragment>
          )}

          <div className='form-group row'>
            <div className='col-12 text-center'>
              <input
                type='submit'
                disabled={isSaving}
                value={isSaving ? "保存中..." : "保存"}
                className='btn btn-primary float-right'
                onClick={this.handleFormSubmit}
              />
              <input
                type='button'
                disabled={isSaving}
                value='キャンセル'
                className='btn btn-white-primary float-right mr-2'
                onClick={handleEditModeLinkClick}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}

InvestmentForm.propTypes = {
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  handleEditModeLinkClick: PropTypes.func.isRequired,
  defaultCompanyImage: PropTypes.string.isRequired
};

export default InvestmentForm;
